import React, {useState, useEffect, useCallback, useMemo, Fragment} from 'react';
import CircularProgressBar from './abroadUsageCircularBar/AbroadUsageCircularBar';
import ProgressBarWrapper from './progressBarWrapper/ProgressBarWrapper';
import Airplane from './images/Airplane.svg';
import WarningIcon from './images/yellowWarning.svg';
import {connect} from 'react-redux';
import {isMobile} from 'react-device-detect';
import {
  setRemovedSurfSocResult,
  setActiveLobbyTab,
  setOtpPhone,
  getExtendedPackageData,
  setSelectedAbroadPackage,
  abroadAddSoc,
  resetAddedExtendedPackageResult,
} from '../CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';
import {getCustomerAbroadUsageDisplay, getUsageData, removePackage} from '../CellcomAbroadLobbyBlock/Shared/abroadThunk';
import {useFetchFamilyBundle} from './hooks/useFamilyBundleUsage';
import {navigateToUrl} from '../../../utilities/StringHelpers/StringHelpers';
import {lobbyTabsEnum} from '../CellcomAbroadLobbyBlock/cellcomAbroadVariables';
import {gaEvent} from '../../../utilities/analytics/tracking';
import gaParams from '../../../utilities/analytics/constants';
import CancelSurfPopUp from '../CellcomAbroadLobbyBlock/PackageExists/PopUps/CancelSurfPopUp';
import ExtendedPackageSurfPopUp from '../CellcomAbroadLobbyBlock/PackageExists/PopUps/ExtendedPackageSurfPopUp';
import SuccessfulPackageInstall from './../CellcomAbroadLobbyBlock/PackageExists/PopUps/SuccessfulPackageInstall';
import SuccessfulSurfBlockRemoved from './../CellcomAbroadLobbyBlock/PackageExists/PopUps/SuccessfulSurfBlockRemoved';
import FailedUpdatePackage from './../CellcomAbroadLobbyBlock/PackageExists/PopUps/FailedUpdatePackage';
import PopUp from '../../Shared/Popup/PopUp';
import CustomTooltip from '../../Shared/CustomToolTip/CustomTooltip';
import {getReportParams, report} from '../../../middleware/report';
import InternetPackageEnding from './internetPackageEnding/InternetPackageEnding';
import AbroadGraphUsageSkeleton from './AbroadGraphUsageSkeleton';
import FamilyPackageUsageDetailsPopUp from './FamilyPackageUsageDetailsPopUp/FamilyPackageUsageDetailsPopUp';

function AbroadCustomerUsageGraphsMain({
  setRemovedSurfSocResult,
  removedSurfSocResult,
  userUsageDataStatus,
  setActiveLobbyTab,
  userUsageData,
  context,
  packageWarning,
  removePackage,
  getExtendedPackageData,
  abroadAddSoc,
  lobbyId,
  costumerMobile,
  otpTicketId,
  addedExtendedPackageResult,
  urlToDataUsageBlock,
  getUsageData,
  resetAddedExtendedPackageResult,
  getCustomerAbroadUsageDisplay,
  isSeparatedSale,
  iContent,
  setOtpPhone,
  isBusinessCostumer,
  isFetchAbroadData,
  familyPackageUsageDetailsPending,
  abroadSocInd,
  isJETAuthentication,
}) {
  const userUsageDataCompleted = userUsageDataStatus === 'fulfilled';
  const isUsageDataPending = userUsageDataStatus === 'pending' || familyPackageUsageDetailsPending;
  const title = iContent.title?.value;
  const linkText = iContent.buttonText?.value;
  const buttonLink = iContent.buttonLink?.value?.url;
  const abroadLobbyPrivateLink = iContent.abroadLobbyPrivateLink?.value?.url;
  const abroadLobbyBusinessLink = iContent.abroadLobbyBusinessLink?.value?.url;
  const morePackagesPrivateLink = iContent.morePackagesPrivateLink?.value?.url;
  const morePackagesBusinessLink = iContent.morePackagesBusinessLink?.value?.url;
  const hasData = userUsageDataCompleted ? userUsageData?.hasData : false;
  const isAbroad = userUsageDataCompleted ? userUsageData?.isAbroad : false;
  const hasCurrentUsage = userUsageDataCompleted ? userUsageData?.hasCurrentUsage : false;
  const hasPreviousUsage = userUsageDataCompleted ? userUsageData?.hasPreviousUsage : false;
  const hasAnyUsages = hasPreviousUsage || hasCurrentUsage;
  const effPackage = userUsageDataCompleted ? userUsageData?.effectivePackagesToShow : [];
  const userType = userUsageDataCompleted ? userUsageData?.userType : '';
  const [showSurfBlock, setShowSurfBlock] = useState(false);
  const [showExtendedSurf, setShowExtendedSurf] = useState(false);
  const [displaySuccessfulPackageInstall, setDisplaySuccessfulPackageInstall] = useState(false);
  const [displayUnsuccessfulPackageInstall, setDisplayUnsuccessfulPackageInstall] = useState(false);
  const [displaySuccessfulSurfBlockRemoved, setDisplaySuccessfulSurfBlockRemoved] = useState(false);

  const flatUsagesArr = useMemo(
    () => effPackage?.flatMap((p) => p?.usages?.map((u) => ({...p, ...u}))) ?? [],
    [effPackage],
  );

  const internetUsages = useMemo(
    () => flatUsagesArr.filter((u) => u.ivrSubCategoryCode === 'RD'),
    [flatUsagesArr],
  );

  const sortedCallsUsages = useMemo(() => {
    const calls = flatUsagesArr.filter((u) => u.ivrSubCategoryCode === 'RA');
    const {byPercentage, byDate} = calls.reduce(
      (acc, u) => {
        if ((Number(u?.percentageUsed) || 0) > 0) acc.byPercentage.push(u);
        else acc.byDate.push(u);
        return acc;
      },
      {byPercentage: [], byDate: []},
    );
    byPercentage.sort((a, b) => a.percentageUsed - b.percentageUsed);
    byDate.sort((a, b) => new Date(a?.startDate) - new Date(b?.startDate));
    return [...byPercentage, ...byDate];
  }, [flatUsagesArr]);

  useEffect(() => {
    const progBarBox = document.getElementById('usage-box-mid');
    if (progBarBox) {
      progBarBox.scrollIntoView({behavior: 'smooth'});
    }
  }, []);

  useEffect(() => {
    const getCustomerAbroadUsage = async () => {
      await getCustomerAbroadUsageDisplay({mobile: costumerMobile});
      await getUsageData({subscriber: costumerMobile, toReport: false});
      setOtpPhone(costumerMobile);
    };
    // if ((userUsageDataStatus != 'pending' && userUsageDataStatus != 'fulfilled') || (!isFetchAbroadData)) {
    if (userUsageDataStatus != 'pending' && userUsageDataStatus != 'fulfilled') {
      getCustomerAbroadUsage();
    }
  }, [costumerMobile, userUsageDataStatus]);

  useEffect(() => {
    if (addedExtendedPackageResult === false) {
      setDisplayUnsuccessfulPackageInstall(true);
    } else if (addedExtendedPackageResult === true) {
      setDisplaySuccessfulPackageInstall(true);
    }
  }, [addedExtendedPackageResult]);

  useEffect(() => {
    if (removedSurfSocResult) {
      setDisplaySuccessfulSurfBlockRemoved(true);
    }
  }, [removedSurfSocResult]);

  useFetchFamilyBundle(costumerMobile);

  const closePopUp = useCallback(() => {
    setShowSurfBlock(false);
    setShowExtendedSurf(false);
    setDisplaySuccessfulPackageInstall(false);
    setDisplayUnsuccessfulPackageInstall(false);
    setDisplaySuccessfulSurfBlockRemoved(false);
    setRemovedSurfSocResult(null);
  }, []);

  const closeSurfPopUp = useCallback(() => {
    setShowSurfBlock(false);
  }, []);

  const navToAbroadLobby = useCallback((link) => navigateToUrl(link), []);

  function getPercentageIntValue(percentage) {
    return Number(percentage) || 0;
  }

  function sortCalls(callsUsages) {
    const {byPercentage, byDate} = callsUsages?.reduce(
      (acc, u) => {
        const percentage = getPercentageIntValue(u?.percentageUsed);
        if (percentage > 0) {
          acc.byPercentage.push(u);
        } else {
          acc.byDate.push(u);
        }
        return acc;
      },
      {byPercentage: [], byDate: []},
    );

    byPercentage.sort((a, b) => a.percentageUsed - b.percentageUsed);
    byDate.sort((a, b) => new Date(a?.startDate) - new Date(b?.startDate));

    return [...byPercentage, ...byDate];
  }

  function renderWarningInfo(icon, text, btnCondition, btnText, btnCallBack, btbCallBackParam, showToolTip = false) {
    return (
      <InternetPackageEnding
        icon={icon}
        text={text}
        btnCondition={btnCondition}
        btnText={btnText}
        btnCallBack={btnCallBack}
        btbCallBackParam={btbCallBackParam}
        showToolTip={showToolTip}
      />
    );
  }

  function getWarningBtnLink(warningData) {
    if (warningData?.warningType === 'ExpiredPackages' || warningData?.warningType === 'OverheadUsageNoBank' || warningData?.warningType === 'NoPackages') {
      return isBusinessCostumer ? abroadLobbyBusinessLink : abroadLobbyPrivateLink;
    }
    return isBusinessCostumer ? morePackagesBusinessLink : morePackagesPrivateLink;
  }

  function checkForWarnings() {
    const warningData = packageWarning ?? null;
    if (warningData && warningData?.showWarning === true) {
      const buttonLink = getWarningBtnLink(warningData);
      const warningTxt = warningData.selfcareWarningText ?? (isMobile ? warningData.warningMobileText : warningData.warningText);
      const warningBtnTxt = warningData.selfcareWarningBtnText ?? warningData.buttonText;
      const showTooltip = warningData.showTooltip;
      const surfWarningCondition =
        isSeparatedSale || userUsageData?.accountSegment?.toUpperCase() === 'CANTSALENOW';
      const surfWarningTxt = surfWarningCondition
        ? '<b>רגע, זה חשוב!</b> המנוי שלך חסום לגלישה בחו"ל<br />פנה לאיש קשר בארגונך בכדי לבטל את חסימת הגלישה.'
        : '<b>רגע, זה חשוב!</b> המנוי שלך חסום לגלישה בחו"ל';
      const surfBtnTxt = 'להסרת החסימה';

      gaEvent(
        gaParams.ABROAD_MY_ABROAD_DISPLAY_WARNING_TYPE.category,
        gaParams.ABROAD_MY_ABROAD_DISPLAY_WARNING_TYPE.eventType,
        warningTxt,
      );

      return (
        <>
          {warningData.warningType != 'NoWarning' &&
            renderWarningInfo(WarningIcon, warningTxt, true, warningBtnTxt, navToAbroadLobby, buttonLink, showTooltip)}

          {warningData &&
            warningData.surfWarning &&
            renderWarningInfo(WarningIcon, surfWarningTxt, !surfWarningCondition, surfBtnTxt, navToAbroadLobby, buttonLink, showTooltip)}
        </>
      );
    }
  }

  function renderUsageDisplayMode() {
    if (hasAnyUsages && hasData && effPackage && effPackage.length > 0) {
      gaEvent(
        gaParams.ABROAD_MY_ABROAD_DISPLAY_MODE_TYPE.category,
        gaParams.ABROAD_MY_ABROAD_DISPLAY_MODE_TYPE.eventType,
        userUsageData?.mode,
      );
      return (
        <div className='AbroadCustomerUsageGraphs'>
          {title && <span className='title'>{title}</span>}

          <div className={`circles-container ${internetUsages?.length < 2 ? 'only-child' : ''}`}>
            {internetUsages?.map((p, i) => (
              <Fragment key={i}>
                <CircularProgressBar usage={p?.percentageUsed} unit={p?.quantityUnitOfMeasure} outOfTotal={p?.quantity} SocData={p} />
              </Fragment>
            ))}
          </div>

          <div className='progress-bars-container'>
            {sortedCallsUsages?.map((p, i) => (
              <ProgressBarWrapper
                key={i}
                serviceName='שיחות'
                servicePackageUnitQuantity={p?.quantity}
                servicePackageUnitMeasure={p?.quantityUnitOfMeasure}
                bgcolor={'var(--theme-primary, #9631ff)'}
                icon={Airplane}
                percentageCompleted={p?.percentageUsed}
                SocData={p}
              />
            ))}
          </div>

          {checkForWarnings()}

          {hasAnyUsages && linkText && (
            <div
              className='link-text'
              onClick={() => {
                navigateToUrl(buttonLink);
              }}>
              {linkText}
              <CustomTooltip
                content={
                  <>
                    ניתן לצרף לחבילה מנוי סלולרי משולמים ע"י אותו בעל ת.ז ומאותו אמצעי תשלום.
                    <br />
                    בנוסף ניתן לשנות את תאריך התחלת החבילה כך שלא יתחיל באותו התאריך של החבילה הראשית. שימו לב כי חבילת בני משפחה הינה לאותם
                    יעדים של החבילה הראשית שנרכשתם
                  </>
                }>
              </CustomTooltip>
            </div>
          )}
        </div>
      );
    } else if (packageWarning && packageWarning.showWarning) {
      return (
        <div className='AbroadCustomerUsageGraphs'>
          {checkForWarnings()}
          {hasAnyUsages && linkText && (
            <div
              className='link-text'
              onClick={() => {
                navigateToUrl(buttonLink);
              }}>
              {linkText}
            </div>
          )}
        </div>
      );
    }
    if (userUsageData?.mode == 'Ticket') {
      gaEvent(
        gaParams.ABROAD_MY_ABROAD_DISPLAY_MODE_TYPE.category,
        gaParams.ABROAD_MY_ABROAD_DISPLAY_MODE_TYPE.eventType,
        userUsageData.mode,
      );
    }
    if (userUsageData?.mode == 'Globe') {
      gaEvent(
        gaParams.ABROAD_MY_ABROAD_DISPLAY_MODE_TYPE.category,
        gaParams.ABROAD_MY_ABROAD_DISPLAY_MODE_TYPE.eventType,
        userUsageData.mode,
      );
    }
    if (userUsageData?.mode == 'CircleBar' && effPackage.length == 0) {
      gaEvent(
        gaParams.ABROAD_MY_ABROAD_DISPLAY_MODE_TYPE.category,
        gaParams.ABROAD_MY_ABROAD_DISPLAY_MODE_TYPE.eventType,
        userUsageData.mode,
      );
    }
  }

  function reportGAWhenBuyPackage(warningObj) {
    gaEvent(
      gaParams.ABROAD_MY_ABROAD_CLICK_WARNING_BTN.category,
      gaParams.ABROAD_MY_ABROAD_CLICK_WARNING_BTN.eventType,
      warningObj.warningTxt,
    );
    let reportParams = {};
    reportParams = getReportParams();
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'Cellcom Abroad';
    reportParams.channel = userUsageData.userType == 'Private' ? 'WebsitePrivate' : 'WebsiteBusiness';
    reportParams.actionType = 'Redirect To Buy A Package';
    reportParams.status = 'Ongoing';
    reportParams.messageText = 'Redirect To Buy A Package';
    reportParams.param1 = 'WEBSITE';
    if (isJETAuthentication) {
      reportParams.param1 = 'JET';
    }
    if (isSeparatedSale || userUsageData?.accountSegment?.toUpperCase() === 'CANTSALENOW') {
      reportParams.param3 = 'מכר בהפרדה';
    }
    report(reportParams);
  }

  async function goToBuyAPackage(warningObj) {
    reportGAWhenBuyPackage(warningObj);

    const data = {
      blockId: lobbyId,
      userType: userType,
      phoneNumber: costumerMobile,
    };

    switch (warningObj.warningType) {
      case 'AlmostFinishedData':
        await getExtendedPackageData(data);
        setShowExtendedSurf(!showExtendedSurf);
        break;
      case 'FinishedData':
        await getExtendedPackageData(data);
        setShowExtendedSurf(!showExtendedSurf);
        break;
      default:
        userType == 'Private' ? setActiveLobbyTab(lobbyTabsEnum.PRIVATE) : setActiveLobbyTab(lobbyTabsEnum.BUSINESSACCOUNT);
        break;
    }
  }

  function renderByDevice() {
    if (abroadSocInd === 'Y') {
      if (isUsageDataPending) {
        return <AbroadGraphUsageSkeleton />;
      }
      if (userUsageDataCompleted) {
        return renderUsageDisplayMode();
      }
    }
  }

  return (
    <>
      <PopUp showPopUp={showSurfBlock} onClose={closeSurfPopUp}>
        {showSurfBlock && (
          <CancelSurfPopUp
            onClose={closeSurfPopUp}
            removePackage={removePackage}
            otpPhone={costumerMobile}
            otpTicketId={otpTicketId}
            getUsageData={getUsageData}
            getCustomerAbroadUsageDisplay={getCustomerAbroadUsageDisplay}
          />
        )}
      </PopUp>
      <PopUp showPopUp={showExtendedSurf} onClose={closePopUp}>
        <ExtendedPackageSurfPopUp onClose={closePopUp} abroadAddSoc={abroadAddSoc} mobile={costumerMobile} otpTicketId={otpTicketId} />
      </PopUp>
      <PopUp showPopUp={displayUnsuccessfulPackageInstall} onClose={closePopUp}>
        <FailedUpdatePackage onClose={closePopUp} resetAddedExtendedPackageResult={resetAddedExtendedPackageResult} />
      </PopUp>
      <PopUp showPopUp={displaySuccessfulPackageInstall} onClose={closePopUp}>
        <SuccessfulPackageInstall onClose={closePopUp} resetAddedExtendedPackageResult={resetAddedExtendedPackageResult} />
      </PopUp>
      <PopUp showPopUp={displaySuccessfulSurfBlockRemoved} onClose={closePopUp}>
        <SuccessfulSurfBlockRemoved onClose={closePopUp} removedSurfSocResult={removedSurfSocResult} />
      </PopUp>
      {renderByDevice()}
    </>
  );
}

const mapStateToProps = (state) => ({
  familyPackageUsageDetailsPending: state.cellcomAbroad.familyPackageUsageDetails.isPending,
  userUsageData: state.selfcarePage.selectedSubscriber?.abroadUsage?.data,
  userUsageDataStatus: state.selfcarePage.selectedSubscriber?.abroadUsage?.status,
  packageWarning: state.cellcomAbroad.subscriberAbroadUsageData?.genericInfo?.packageWarning,
  lobbyId: state.cellcomAbroad.epiStyleInitializationData.lobbyBlockId,
  costumerMobile: state.selfcarePage?.selectedSubscriber?.productSubscriberNo,
  abroadSocInd: state.selfcarePage?.selectedSubscriber?.abroadSocInd,
  isBusinessCostumer: state.selfcarePage?.selectedSubscriber?.isBusinness,
  addedExtendedPackageResult: state.cellcomAbroad.addedExtendedPackageResult,
  urlToDataUsageBlock: state.cellcomAbroad.epiStyleInitializationData.urlToDataUsageBlock,
  removedSurfSocResult: state.cellcomAbroad.removedSurfSocResult,
  isSeparatedSale: state.cellcomAbroad.otpData?.validatedCostumerData?.isSeparatedSale,
  isJETAuthentication: state.cellcomAbroad.isJETAuthentication,
  isFetchAbroadData: state.selfcarePage?.selectedSubscriber?.isFetchAbroadData,
});

const mapDispatchToProps = {
  setActiveLobbyTab,
  removePackage,
  getExtendedPackageData,
  setSelectedAbroadPackage,
  abroadAddSoc,
  getUsageData,
  resetAddedExtendedPackageResult,
  getCustomerAbroadUsageDisplay,
  setRemovedSurfSocResult,
  setOtpPhone,
};

export default connect(mapStateToProps, mapDispatchToProps)(AbroadCustomerUsageGraphsMain);
